import PlaylistEventsManager from "../../Devices/PlaylistEventsManager";
import { PlaylistEvents } from "../../Devices/PlaylistEventsManager.interface";
import type TriggerEngine from "../../TriggerEngine";
import type { EventSourceResult } from "../../TriggerEngine.interfaces";

export const wirePlaylistEvents = (
  engine: TriggerEngine,
): EventSourceResult => {
  const onTrackEnded = (payload?: { trackId: number }) => {
    engine.fireEvent(
      "track_ended",
      payload ? { trackId: String(payload.trackId) } : undefined,
    );
  };
  const onStarted = () => engine.fireEvent("playlist_started");
  const onStopped = () => engine.fireEvent("playlist_stopped");
  const onEnded = () => engine.fireEvent("playlist_ended");

  PlaylistEventsManager.watch(PlaylistEvents.TrackEnded, onTrackEnded);
  PlaylistEventsManager.watch(PlaylistEvents.Started, onStarted);
  PlaylistEventsManager.watch(PlaylistEvents.Stopped, onStopped);
  PlaylistEventsManager.watch(PlaylistEvents.Ended, onEnded);

  return {
    unsubscribers: [
      () =>
        PlaylistEventsManager.unwatch(PlaylistEvents.TrackEnded, onTrackEnded),
      () => PlaylistEventsManager.unwatch(PlaylistEvents.Started, onStarted),
      () => PlaylistEventsManager.unwatch(PlaylistEvents.Stopped, onStopped),
      () => PlaylistEventsManager.unwatch(PlaylistEvents.Ended, onEnded),
    ],
  };
};
